export default {"src":"/_next/static/media/skillz_logo.902fd2a7.svg","height":21,"width":82,"blurWidth":0,"blurHeight":0};